<template>
  <div class="parking-coupon-container" @click="showKeyboard = false">
    <div class="receive-before" v-if="!isSuccess">
      <div class="header-title">扫码领券</div>

      <div class="content">
        <div class="row1">
          <div class="leading">
            <span>车牌号码</span>
            <i>*</i>
          </div>
        </div>
        <div class="vehicle-type-list">
          <span
            :class="[vehicleType === 0 ? 'active' : '']"
            @click="changeVehicleModel(0)"
          >
            新能源
          </span>
          <span
            :class="[vehicleType === 1 ? 'active' : '']"
            @click="changeVehicleModel(1)"
          >
            燃油车
          </span>
        </div>
        <div class="row2">
          <div class="list" @click.stop="showKeyboard = true">
            <div class="item" v-for="(p, index) in plateLen" :key="index">
              <span :class="[index === 0 ? 'province' : 'num']">{{
                plateNumber[index]
              }}</span>
            </div>
          </div>
        </div>
        <div :class="['row3', plateNumber.length === plateLen ? 'active' : '']">
          <div
            class="btn"
            @click="
              plateNumber.length === plateLen ? (showConfirm = true) : null
            "
          >
            立即领取
          </div>
        </div>
      </div>

      <div class="rule-container">
        <div class="title">规则说明</div>
        <div class="list">
          <div class="item">
            <div class="rule">停车券领取规则</div>
            <div class="desc">
              每张车辆一天只可以领取20次停车券，不可多次领取
            </div>
          </div>
          <div class="item">
            <div class="rule">停车券的有效期</div>
            <div class="desc">
              停车券自领取之日起，当日立即可生效，有效期为三天，超时将失效
            </div>
          </div>
          <div class="item">
            <div class="rule">停车券使用规则</div>
            <div class="desc">
              每张停车券每日仅可使用一次，不可重复使用，失效后重新领取
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="receive-after" v-else>
      <div class="status">
        <i class="smile-icon" />
        <span>恭喜您，领取成功</span>
      </div>

      <div class="content">
        <div class="primary-box">
          <div class="top">
            <i class="success-icon" />
            <span class="hint">停车券领取成功</span>
          </div>
          <div class="duration" v-if="false">免费停车2小时</div>
          <div class="desc">
            仅限车牌号<span>{{ plateNumber }}</span
            >使用
          </div>
        </div>
        <div class="rule-box">
          <div class="t">规则说明</div>

          <div class="rule-list">
            <div class="item">
              <div class="rule">停车券领取规则</div>
              <div class="desc">
                每张车辆一天只可以领取20次停车券，不可多次领取
              </div>
            </div>
            <div class="item">
              <div class="rule">停车券的有效期</div>
              <div class="desc">
                停车券自领取之日起，当日立即可生效，有效期为三天，超时将失效
              </div>
            </div>
            <div class="item">
              <div class="rule">停车券使用规则</div>
              <div class="desc">
                每张停车券每日仅可使用一次，不可重复使用，失效后重新领取
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-popup
      v-model="showConfirm"
      round
      duration="0"
      :style="{ height: '220px' }"
    >
      <div class="van-popup--container">
        <div class="title">提醒</div>
        <div class="middle">
          <div class="p1">您输入的车牌号为 {{ plateNumber }}</div>
          <div class="desc">请认真核对车牌信息，是否确认无误❓</div>
        </div>
        <div class="btns">
          <div class="btn" @click="handleInputError">输入有误</div>
          <div class="btn" @click="onSubmit">是，我确认</div>
        </div>
      </div>
    </van-popup>

    <div :class="['keyboard-placeholder', showKeyboard ? 'active' : '']"></div>
    <div
      @click.stop="stopEvent"
      :class="['keyboard', showKeyboard ? 'active' : '']"
    >
      <span class="done" @click="showKeyboard = false">完成</span>
      <div class="keyboard-list">
        <div
          :class="['item', keyboardMode === 1 && index <= 9 ? 'gray-bg' : '']"
          v-for="(k, index) in keys"
          :key="index"
          @click="handleClick(k)"
        >
          {{ k }}
        </div>
        <!-- <div :class="['options', keyboardMode === 1 ? 'small' : '']">
          <button class="letter btn" @click="changeKeyboardMode">
            {{ keyboardMode === 0 ? 'ABC' : '省份' }}
          </button>
          <button class="delete btn" @click="onRemove">删除</button>
        </div> -->
        <div class="options">
          <button class="delete btn" @click="onRemove">删除</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCoupon } from '@/api/modules/parking'

const placeholderText = '省'

export default {
  created() {
    const { id } = this.$route.query
    this.merchantId = id
  },
  data: () => ({
    showConfirm: false,
    isSuccess: false,
    provinces: [
      '京',
      '津',
      '冀',
      '晋',
      '蒙',
      '辽',
      '吉',
      '黑',
      '沪',
      '苏',
      '浙',
      '皖',
      '闽',
      '赣',
      '鲁',
      '豫',
      '鄂',
      '湘',
      '粤',
      '桂',
      '琼',
      '渝',
      '川',
      '云',
      '贵',
      '藏',
      '陕',
      '甘',
      '青',
      '宁',
      '新'
    ],
    letters: [
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '0',
      'Q',
      'W',
      'E',
      'R',
      'T',
      'Y',
      'U',
      // 'I',
      // 'O',
      'P',
      'A',
      'S',
      'D',
      'F',
      'G',
      'H',
      'J',
      'K',
      'L',
      'Z',
      'X',
      'C',
      'V',
      'B',
      'N',
      'M'
    ],
    keyboardMode: 0, // 0 省份, 1 ABC & 0-9
    showKeyboard: false,
    plateNumber: placeholderText,
    plateLen: 8,
    vehicleType: 0, // 0 燃油车, 1 新能源
    merchantId: null
  }),
  watch: {
    plateNumber(newVal) {
      if (newVal.length >= 1 && newVal !== placeholderText) {
        this.keyboardMode = 1
      } else {
        this.keyboardMode = 0
      }
    },
    vehicleType(newVal) {
      if (newVal === 0) {
        this.plateLen = 8
      } else {
        this.plateLen = 7
      }
    }
  },
  computed: {
    keys() {
      if (this.keyboardMode === 0) {
        return this.provinces
      }
      return this.letters
    }
  },
  methods: {
    changeKeyboardMode() {
      if (
        this.plateNumber === placeholderText ||
        this.plateNumber.length >= 1
      ) {
        return
      }
      this.keyboardMode = this.keyboardMode === 0 ? 1 : 0
    },
    stopEvent() {},
    handleClick(d) {
      if (this.plateNumber.length >= this.plateLen) {
        return
      }
      if (this.plateNumber === placeholderText) {
        this.plateNumber = ''
      }
      this.plateNumber += d
    },
    onRemove() {
      if (this.plateNumber.length === 1) {
        this.plateNumber = placeholderText
        return
      }
      this.plateNumber = this.plateNumber.substr(0, this.plateNumber.length - 1)
    },
    changeVehicleModel(vehicleType) {
      // 新能源切换到燃油车删除最后一位
      this.vehicleType = vehicleType

      if (this.plateNumber.length === this.plateLen && this.vehicleType === 1) {
        this.plateNumber = this.plateNumber.substr(
          0,
          this.plateNumber.length - 1
        )
      }
    },
    handleInputError() {
      this.showConfirm = false
      setTimeout(() => {
        this.showKeyboard = true
      }, 60)
    },
    async onSubmit() {
      this.showConfirm = false
      const { merchantId, plateNumber: licensePlateNumber } = this

      await getCoupon({
        merchantId,
        licensePlateNumber
      })
      this.isSuccess = true
    }
  }
}
</script>

<style lang="scss">
html,
body {
  background: transparent;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.app-container {
  width: 100%;
  height: 100%;
}

.parking-coupon-container {
  overflow-y: scroll;
  width: 100%;
  height: 100%;

  &::-webkit-scrollbar {
    width: 0;
    display: none;
  }

  .receive-before {
    min-height: 100%;
    background: url('../../assets/images/parking-coupon/bg.png') 0 0 / 100%
      no-repeat;
    overflow: hidden;

    .header-title {
      text-align: center;
      font-weight: 500;
      font-size: 16px;
      color: #fff;
      height: 44px;
      line-height: 44px;
      margin-top: 10px;
    }
    .content {
      background: #fff;
      margin: 157px 14px 0;
      border-radius: 8px;
      padding: 20px 15px 18px;
      box-sizing: border-box;

      .row1 {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .leading {
          span {
            color: #222;
            font-size: 18px;
          }

          i {
            vertical-align: middle;
            font-size: 20px;
            color: #e4291c;
          }
        }
      }

      .vehicle-type-list {
        margin-top: 14px;
        display: flex;

        span {
          color: #666;
          font-size: 14px;
          font-weight: 500;
          margin-right: 30.5px;
          display: flex;
          flex-direction: column;
          align-items: center;

          &.active {
            color: #2364e5;
            font-weight: 700;
            font-size: 16px;

            &::after {
              content: '';
              display: block;
              width: 60%;
              height: 2px;
              background: #2263e5;
              margin-top: 3px;
            }
          }
        }
      }

      .row2 {
        margin-top: 18px;

        .list {
          display: flex;
          justify-content: space-between;

          .item {
            width: 32px;
            height: 46px;
            background: #f5f5f5;
            border-radius: 4px;
            text-align: center;
            line-height: 46px;
            border: 0.5px solid #e5e5e5;

            .num {
              font-weight: 700;
              font-size: 24px;
              color: #333333;
            }

            .province {
              display: inline-block;
              width: 100%;
              height: 100%;
              font-weight: 700;
              font-size: 22px;
              color: rgba(61, 118, 236, 0.4);
              background: rgba(15, 76, 182, 0.1);
              border: none;
            }
          }
        }
      }

      .row3 {
        height: 50px;
        margin-top: 30px;
        background: linear-gradient(270deg, #2263e5 0%, #479cf4 100%);
        opacity: 0.4;
        box-shadow: 2px 4px 8px rgba(42, 111, 232, 0.3);
        border-radius: 4px;
        line-height: 50px;
        text-align: center;

        &.active {
          opacity: 1;

          .btn {
            opacity: 1;
          }
        }

        .btn {
          font-weight: 400;
          font-size: 20px;
          color: #ffffff;
          opacity: 0.5;
        }
      }
    }

    .rule-container {
      margin-top: 40px;

      .title {
        color: #333;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        position: relative;

        &::before,
        &::after {
          content: '';
          display: block;
          width: 110px;
          height: 1px;
          background: #b4cee8;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }

        &::before {
          left: 28px;
        }

        &::after {
          right: 28px;
        }
      }

      .list {
        padding: 22px 30px 0;

        .item {
          margin-bottom: 18px;

          .rule {
            font-size: 14px;
            color: #333;
            font-weight: bold;
            display: flex;
            align-items: center;

            &::before {
              content: '';
              display: block;
              width: 6px;
              height: 6px;
              background: #999;
              border-radius: 50%;
              margin-right: 6px;
            }
          }
          .desc {
            margin-left: 12px;
            font-size: 12px;
            color: #666;
            margin-top: 12px;
          }
        }
      }
    }
  }

  .receive-after {
    width: 100%;
    min-height: 100%;
    background: url('../../assets/images/parking-coupon/success-bg.png') 0 0 /
      100% no-repeat;
    overflow: hidden;

    .status {
      margin-top: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      font-weight: 700;
      color: #fff;

      .smile-icon {
        width: 26px;
        height: 26px;
        background: url('../../assets/images/parking-coupon/smile-icon.png')
          100% / 100%;
        margin-right: 8px;
      }
    }

    .content {
      margin: 20px 14px 0;
      background: #fff;
      padding: 16px;
      border-radius: 8px;
      position: relative;

      .primary-box {
        border: 1px dashed rgba(35, 100, 229, 0.35);
        border-radius: 3px;
        padding: 27px 34px 25px;
        text-align: center;

        .top {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          color: #333;
          font-weight: 700;

          .success-icon {
            width: 22px;
            height: 22px;
            background: url('../../assets/images/parking-coupon/success-icon.png')
              100% / 100%;
            margin-right: 6px;
          }
        }

        .duration {
          margin-top: 30px;
          height: 50px;
          background: rgba(35, 100, 229, 0.1);
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #2364e5;
          font-size: 18px;
          font-weight: 700;
        }

        .desc {
          margin-top: 26px;
          font-size: 16px;
          color: #666;

          span {
            color: #333;
            font-weight: 700;
            margin: 0 6px;
          }
        }
      }

      .rule-box {
        margin-top: 23px;

        .t {
          font-weight: 700;
          text-align: center;
          font-size: 16px;
          color: #333333;

          &::before,
          &::after {
            content: '';
            position: absolute;
            width: 20px;
            height: 20px;
            background: linear-gradient(180deg, #0f4cb6 0%, #1450b8 100%);
            border-radius: 50%;
          }

          &::before {
            left: 0;
            transform: translateX(-50%);
          }

          &::after {
            right: 0;
            transform: translateX(50%);
          }
        }

        .rule-list {
          padding: 22px 0px 0;

          .item {
            margin-bottom: 18px;

            .rule {
              font-size: 14px;
              color: #333;
              font-weight: bold;
              display: flex;
              align-items: center;

              &::before {
                content: '';
                display: block;
                width: 6px;
                height: 6px;
                background: #999;
                border-radius: 50%;
                margin-right: 6px;
              }
            }
            .desc {
              margin-left: 12px;
              font-size: 12px;
              color: #666;
              margin-top: 12px;
            }
          }
        }
      }
    }
  }

  .van-popup {
    &--center {
      top: 306px;
    }

    &--round {
      border-radius: 8px;
    }

    &--container {
      width: 320px;
      height: 100%;
      padding: 17px 24px 19px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .title {
        font-size: 18px;
        color: #333;
        font-weight: 700;
      }

      .middle {
        .p1 {
          color: #2364e5;
          font-size: 18px;
          font-weight: 700;
        }

        .desc {
          font-size: 14px;
          color: #666;
          margin-top: 16px;
        }
      }

      .btns {
        display: flex;
        justify-content: space-between;

        .btn {
          width: 128px;
          height: 44px;
          border-radius: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          font-weight: 700;

          &:first-child {
            color: #ef2928;
            background: rgba(239, 41, 40, 0.15);
          }

          &:last-child {
            background: #2364e5;
            color: #fff;
          }
        }
      }
    }
  }

  .keyboard-placeholder {
    height: 270px;
    width: 100%;
    display: none;

    &.active {
      display: block;
    }
  }

  .keyboard {
    background: #c5d1e4;
    width: 100%;
    height: 0;
    bottom: 0;
    position: absolute;
    transition: height 0.2s;
    text-align: end;
    z-index: 99;

    &.active {
      height: 270px;

      .done {
        display: inline-block;
      }

      .keyboard-list {
        display: flex;
      }
    }

    .done {
      display: none;
      line-height: 40px;
      color: #2364e5;
      font-size: 16px;
      font-weight: 500;
      padding-right: 10px;
      text-align: end;
    }

    &-list {
      padding: 0px 5px 10px;
      display: flex;
      flex-wrap: wrap;
      position: relative;
      display: none;

      .item {
        width: 32px;
        height: 42px;
        background: #ffffff;
        box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.3);
        border-radius: 6px;
        text-align: center;
        line-height: 42px;
        font-size: 18px;
        margin-right: 5px;
        margin-bottom: 6px;
        border: none;

        &.gray-bg {
          background: #eee;
        }

        &:active {
          background: #2364e5;
          color: #fff;
        }

        &:nth-child(10n) {
          margin-right: 0;
        }
      }

      .options {
        position: absolute;
        right: 5px;
        bottom: 16px;
        display: flex;

        &.small {
          .btn {
            width: 69px;
          }
        }

        .btn {
          width: 76px;
          height: 42px;
          box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.3);
          border-radius: 6px;
          background: #ffffff;
          line-height: 42px;
          text-align: center;
          margin-left: 6px;
          font-size: 18px;
          border: none;

          &.delete {
            background: #9eabbe;
          }

          &:active {
            background: #2364e5;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
